import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';

import EvaluationSubmissionAnswer from './EvaluationSubmissionAnswer';
import EvaluationAnswerComposer from './EvaluationAnswerComposer';

const Irrelevance = styled.div`
	text-align: center;
	background: white;
	border-radius: 10px;
	padding: 20px 80px;
	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 17px;
`;

export default function EvaluationSubmissionItemContents(props: {
	hideEmployeeForReviewGoal?: boolean;
	hideManagerForReviewGoal?: boolean;
	section: number;
	item: number;
	metadata?: { goal: graphql.EvaluationSubmissionGoal };
	submission: graphql.EvaluationSubmission;
	relevant: boolean;
	required: boolean;
	fillInBy: { manager: boolean; employee: boolean };
	onSave: () => void;
	isSaving: boolean;
}) {
	const { t } = useTranslation();

	const item = props.submission.evaluationForm.sections[props.section].items[props.item];

	if (
		(props.submission.employee.hasShared && props.submission.employee.requiresInput) ||
		(props.submission.manager.hasShared && props.submission.manager.requiresInput)
	) {
		return (
			<>
				{props.hideEmployeeForReviewGoal ? null : (
					<EvaluationSubmissionAnswer
						submission={props.submission}
						party={graphql.EvaluationSubmissionParty.Employee}
						item={props.item}
						metadata={props.metadata}
						section={props.section}
						relevant={props.fillInBy.employee}
						onSave={props.onSave}
						isSaving={props.isSaving}
					/>
				)}
				{props.hideManagerForReviewGoal ? null : (
					<EvaluationSubmissionAnswer
						submission={props.submission}
						party={graphql.EvaluationSubmissionParty.Manager}
						item={props.item}
						metadata={props.metadata}
						section={props.section}
						relevant={props.fillInBy.manager}
						onSave={props.onSave}
						isSaving={props.isSaving}
					/>
				)}
			</>
		);
	} else if (props.relevant && props.required !== false) {
		return (
			<EvaluationAnswerComposer
				autosave
				section={props.section}
				item={props.item}
				metadata={props.metadata}
				submission={props.submission}
				result={props.submission.viewer}
				isSaving={props.isSaving}
				side={props.fillInBy.employee ? 'left' : 'right'}
			/>
		);
	} else {
		return (
			<Irrelevance>
				{t(`evaluation.submission.irrelevant.${item.fillInBy.toLowerCase()}`)}
			</Irrelevance>
		);
	}
}
